// A notice when the room ends for this screen: no room has the code, this page
// is an older build than the server, or the seat opened in another tab. Each
// one has one way on. The words are plain placeholders.

import { el } from '../lib/dom';
import { leaveRoom } from '../state/room';
import { type RoomStatus, roomStore } from '../state/roomStore';

type Notice = {
  title: string;
  line: (code: string) => string;
  action: string;
  onAction: () => void;
};

const reload = (): void => window.location.reload();

const NOTICES: Partial<Record<RoomStatus, Notice>> = {
  gone: {
    title: 'No such room',
    line: (code) => `No room has the code ${code}. A room ends a day after its last move.`,
    action: 'Play the AI',
    onAction: leaveRoom,
  },
  old: {
    title: 'A new version is out',
    line: () => 'Reload to get it. The match is on the server, so nothing is lost.',
    action: 'Reload',
    onAction: reload,
  },
  replaced: {
    title: 'Open somewhere else',
    line: () => 'Your seat in this room opened in another tab or on another device.',
    action: 'Play here',
    onAction: reload,
  },
};

export const createRoomNotice = (): HTMLDialogElement => {
  const title = el('h2', { className: 'room-notice__title' });
  const line = el('p', { className: 'room-notice__line' });
  const action = el('button', { className: 'button button--primary', type: 'button' });
  const root = el('dialog', { className: 'modal room-notice' }, [title, line, action]);
  root.addEventListener('cancel', (event) => event.preventDefault());

  roomStore.subscribe((room) => {
    const notice = room ? NOTICES[room.status] : undefined;
    if (!room || !notice) {
      if (root.open) root.close();
      return;
    }
    title.textContent = notice.title;
    line.textContent = notice.line(room.code);
    action.textContent = notice.action;
    action.onclick = notice.onAction;
    if (!root.open && root.isConnected) root.showModal();
  });
  return root;
};
